import React from "react";
import { FileToUpload } from "./IdCheckLoopRegula";

export interface DisplayThumbnailProps {
  fileToUpload: FileToUpload;
  onRemove: (
    e: React.KeyboardEvent<HTMLDivElement>,
    setImage: React.Dispatch<React.SetStateAction<FileToUpload>>,
  ) => void;
  setImage: React.Dispatch<React.SetStateAction<FileToUpload>>;
}

export const DisplayThumbnail = ({ fileToUpload, onRemove, setImage }: DisplayThumbnailProps) => {
  const fileName = fileToUpload.file?.name;

  return (
    <div className="sid-step-id-check-loop__thumbnail-main-wrapper">
      <div className="sid-step-id-check-loop__thumbnail-wrapper">
        <img
          className="sid-step-id-check-loop__file-thumbnail"
          src={fileToUpload.url}
          alt="File thumbnail"
        />
      </div>
      <div className="sid-step-id-check-loop__file-name-wrapper">
        <div className="sid-step-id-check-loop__file-name" title={fileName}>
          {fileName}
        </div>
        <div
          role="button"
          tabIndex={0}
          aria-label={`Remove file ${fileName}`}
          className="sid-step-id-check-loop__remove-btn"
          onClick={() => setImage(undefined)}
          onKeyDown={(e) => onRemove(e, setImage)}
        />
      </div>
    </div>
  );
};
